import React, { useMemo } from 'react'
import { loadStripe } from '@stripe/stripe-js/pure'
import * as config from 'config'
import { Elements } from '@stripe/react-stripe-js'

import Payment from './payment'

export default function PaymentNew(props) {
  const stripe = useMemo(() => loadStripe(config.STRIPE_API_KEY), [])
  return (
    <Elements stripe={stripe}>
      <Payment {...props} />
    </Elements>
  )
}
